import React from 'react';
import Slider from "react-slick";
import { useContext } from 'react';
import { AppContext } from '../../AppContext';
import { Link } from 'react-router-dom';
import "./Listing.css";


const Listing = ({ post, onBookmark, isBookmarked, onClickListing, showEditButton, showDeleteButton, onDelete }) => {
    const { isLoggedIn } = useContext(AppContext);

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        className: post.images.length === 1 ? 'single-image' : '',
        lazyLoad: true,
        adaptiveHeight: true,
        customPaging: () => <button />,
        dotsClass: 'slick-dots'
    };
    
    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
        return date.toLocaleDateString('en-US', { 
            month: 'numeric', 
            day: 'numeric', 
            year: 'numeric' 
        });
    };

    const handleSliderControlClick = (e) => { // don't open modal when clicking on the slider controls
        if (e.target.matches('.slick-arrow') || e.target.matches('.slick-dots *')) {
            e.stopPropagation();
        }
    };

    const arrayBufferToBase64 = (buffer) => {
        let binary = '';
        const bytes = new Uint8Array(buffer);
        for (let i = 0; i < bytes.byteLength; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    };

    const renderImages = () => {
        const validImages = post.images.filter(image => image);
        if (validImages && validImages.length >= 1) {
            return (
                <div onClick={handleSliderControlClick}>
                    <Slider {...settings}>
                        {validImages.map((image, index) => (
                            <div key={index}>
                                <img className="single-image"
                                    src={`data:${image.contentType};base64,${arrayBufferToBase64(image.data.data)}`}
                                    alt={`apartment ${index + 1}`} 
                                />
                            </div>
                        ))}
                    </Slider>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="card listing-item" onClick={() => onClickListing(post)}>
            <div className="card-body">
                <div className="slider-container">
                    {renderImages()}
                </div>
                <p className="card-text address-text">{post.address}, {post.city}</p>
                {onBookmark && isLoggedIn && ( // only show bookmark button if onBookmark is provided
                    // if the post is bookmarked, disable the button and show "Bookmarked"
                    <button 
                        className={`bookmark-btn ${isBookmarked ? 'bookmarked' : ''}`}
                        onClick={(e) => {
                            e.stopPropagation();
                            onBookmark(post._id);
                        }}
                    >
                        <i className={`fas ${isBookmarked ? 'fa-bookmark' : 'fa-bookmark-o'}`}></i>
                        {isBookmarked ? "Saved" : "Save"}
                    </button>
                )}
                <p className="card-text name-text">{post.name}</p>
                <p className="card-text"><strong>Contact:</strong> {post.contact || ''}</p>
                <p className="card-text"><strong>Rent:</strong> ${post.rent || ''}</p>
                <p className="card-text"><strong>Availability:</strong> {formatDate(post.startDate)} - {formatDate(post.endDate)}</p>
                
                <div className="text-center text-muted mt-2">
                    <small>
                        <i className="fas fa-search"></i> Click for more details
                    </small>
                </div>
                <div className="d-flex gap-2 mt-2">
                    {showEditButton && (
                        <Link 
                            to={`/edit-post/${post._id}`} 
                            className="btn btn-primary flex-grow-1"
                            onClick={(e) => e.stopPropagation()} 
                        >
                            Edit Listing
                        </Link>
                    )}
                    {showDeleteButton && (
                        <button 
                            className="btn btn-danger flex-grow-1"
                            onClick={(e) => {
                                e.stopPropagation();
                                if (window.confirm('Are you sure you want to delete this listing?')) {
                                    onDelete(post._id);
                                }
                            }}
                        >
                            Delete
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Listing;